import { create } from 'zustand';
import type { Perfil, PerfilResumen } from '../../api-client/perfiles/perfil';
import {
  actualizarPerfil,
  desactivarPerfil,
  obtenerPerfilesActivos,
  obtenerPerfilesPaginados,
  obtenerPerfilPorId,
  registrarPerfil,
  type ActualizarPerfilRequest,
  type RegistrarPerfilRequest
} from '../../api-client/perfiles/perfiles.api';
import type { Modulo } from '../../api-client/permisos/modulo';
import { obtenerPermisosDisponibles } from '../../api-client/permisos/permisos.api';
import type { PaginatedList } from '../common/padinated-list';
import type { PaginationQueryParamsWithStatus } from '../common/pagination-query-params';
import { useUIStore } from '../ui/ui.store';

export interface PerfilesState {
  list: PaginatedList<PerfilResumen>;
  current: Perfil;
  actives: PerfilResumen[];
  modulos: Modulo[];

  nuevo: () => void;
  cargarPaginados: (params: PaginationQueryParamsWithStatus) => Promise<void>;
  cargarActivos: () => Promise<void>;
  cargarPorId: (id: number) => Promise<void>;
  registrar: (request: RegistrarPerfilRequest) => Promise<boolean>;
  actualizar: (id: number, request: ActualizarPerfilRequest) => Promise<boolean>;
  desactivar: (id: number) => Promise<boolean>;

  cargarPermisosDisponibles: () => Promise<void>;
}

const { showSuccessToast } = useUIStore.getState();

export const usePerfilesStore = create<PerfilesState>()((set, get) => ({
  list: {
    items: [],
    pageIndex: 0,
    pageSize: 10,
    totalRows: 0
  },
  current: {} as Perfil,
  actives: [],
  modulos: [],

  nuevo: () =>
    set({
      current: {} as Perfil
    }),
  cargarPaginados: async (params: PaginationQueryParamsWithStatus) => {
    const response = await obtenerPerfilesPaginados(params);

    if (response.isFailure) return;

    set({
      list: response.result
    });
  },
  cargarActivos: async () => {
    const response = await obtenerPerfilesActivos();

    if (response.isFailure) return;

    set({
      actives: response.result
    });
  },
  cargarPorId: async (id: number) => {
    const response = await obtenerPerfilPorId(id);

    if (response.isFailure) return;

    set({
      current: response.result
    });
  },
  registrar: async (request: RegistrarPerfilRequest) => {
    const response = await registrarPerfil(request);

    if (response.isFailure) return false;

    showSuccessToast('Perfil registrado exitosamente');
    return true;
  },
  actualizar: async (id: number, request: ActualizarPerfilRequest) => {
    const response = await actualizarPerfil(id, request);

    if (response.isFailure) return false;

    showSuccessToast('Perfil actualizado exitosamente');

    // set({
    //   current: {
    //     ...get().current,
    //     ...request
    //   }
    // });

    return true;
  },
  desactivar: async (id: number) => {
    const response = await desactivarPerfil(id);

    if (response.isFailure) return false;

    showSuccessToast('Perfil desactivado exitosamente');

    set({
      current: {
        ...get().current,
        activo: false
      }
    });

    return true;
  },
  cargarPermisosDisponibles: async () => {
    const response = await obtenerPermisosDisponibles();

    if (response.isFailure) return;

    set({
      modulos: response.result
    });
  }
}));
